import { useLanguage } from '@hydrogen/elements.core.i18n';
import { sharedContainer, ClientIdService } from '@dekafvv/sharedfrontend';
import { getContactDetails, useGetContactAccounts } from 'services/contactQueryes';
import { getSchemaListByKeyQuery, useGetRiskCategories } from 'services/commonQueryes';
import { useGetPortfolioDetails, useGetPortfolioAccounts } from 'services/queries/portfolioQueries';
import { usePostFoundingsSearch } from 'services/queries/savingQueries';
import { useClientPortfolioIds } from 'components/InvestmentDetails/hooks';
import { useGetSecuritiesComponentsById, useGetSecuritiesById } from 'services/queries/securities';
import { usePostOrderBook } from 'services/queries/wkQueryes';
import {
    useGetContactGroupsById,
    useGetAllPortfolios,
    useGetContactPortfolioOrderbook,
    useSendMtan,
} from 'shared/Api';
import { useFormContext } from 'react-hook-form';
import { useFormValues } from 'hooks/useFormValues';
import { useGetGlobalSettingByGroupAndKey } from 'shared/settings';
import { usePortfolioName } from 'hooks/usePortfolioName';
import { getContactGroupsById } from 'shared/Api/model/contacts/requests';
import { useSearchScheduledOrders } from 'shared/Api/model/contacts/queries';

sharedContainer.bind<typeof getContactDetails>('getContactDetails').toFunction(getContactDetails);
sharedContainer.bind<typeof getSchemaListByKeyQuery>('getSchemaListByKeyQuery').toFunction(getSchemaListByKeyQuery);
sharedContainer.bind<typeof useLanguage>('useLanguage').toFunction(useLanguage);
sharedContainer.bind('clientId').to(ClientIdService).inSingletonScope();
sharedContainer.bind<typeof getContactGroupsById>('getContactGroupsById').toFunction(getContactGroupsById);

sharedContainer.bind<typeof useGetPortfolioDetails>('useGetPortfolioDetails').toFunction(useGetPortfolioDetails);
sharedContainer.bind<typeof useGetRiskCategories>('useGetRiskCategories').toFunction(useGetRiskCategories);
sharedContainer.bind<typeof usePostFoundingsSearch>('usePostFoundingsSearch').toFunction(usePostFoundingsSearch);
sharedContainer.bind<typeof useGetPortfolioAccounts>('useGetPortfolioAccounts').toFunction(useGetPortfolioAccounts);
sharedContainer.bind<typeof useClientPortfolioIds>('useClientPortfolioIds').toFunction(useClientPortfolioIds);
sharedContainer.bind<typeof useGetSecuritiesComponentsById>('useGetSecuritiesComponentsById').toFunction(useGetSecuritiesComponentsById);
sharedContainer.bind<typeof useGetSecuritiesById>('useGetSecuritiesById').toFunction(useGetSecuritiesById);
sharedContainer.bind<typeof useGetContactAccounts>('useGetContactAccounts').toFunction(useGetContactAccounts);
sharedContainer.bind<typeof usePostOrderBook>('usePostOrderBook').toFunction(usePostOrderBook);
sharedContainer.bind<typeof useGetContactGroupsById>('useGetContactGroupsById').toFunction(useGetContactGroupsById);
sharedContainer.bind<typeof useGetAllPortfolios>('useGetAllPortfolios').toFunction(useGetAllPortfolios);
sharedContainer.bind<typeof useGetGlobalSettingByGroupAndKey>('useGetGlobalSettingByGroupAndKey').toFunction(useGetGlobalSettingByGroupAndKey);
sharedContainer.bind<typeof useSendMtan>('useSendMtan').toFunction(useSendMtan);
sharedContainer.bind<typeof usePortfolioName>('usePortfolioName').toFunction(usePortfolioName);

sharedContainer.bind<typeof useFormContext>('useFormContext').toFunction(useFormContext);
sharedContainer.bind<typeof useFormValues>('useFormValues').toFunction(useFormValues);
sharedContainer.bind<typeof useGetContactPortfolioOrderbook>('useGetContactPortfolioOrderbook').toFunction(useGetContactPortfolioOrderbook);
sharedContainer.bind<typeof useSearchScheduledOrders>('useSearchScheduledOrders').toFunction(useSearchScheduledOrders);
